import { render, staticRenderFns } from "./custom-card.vue?vue&type=template&id=c193a272&scoped=true"
import script from "./custom-card.vue?vue&type=script&lang=js"
export * from "./custom-card.vue?vue&type=script&lang=js"
import style0 from "./custom-card.vue?vue&type=style&index=0&id=c193a272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c193a272",
  null
  
)

export default component.exports